// Action from Action Type

import {
  GET_PURCHASE_LIST,
  GET_PURCHASE_LIST_SUCCESS,
  GET_PURCHASE_LIST_FAILURE,
  GET_SINGLE_PURCHASE,
  GET_SINGLE_PURCHASE_SUCCESS,
  GET_SINGLE_PURCHASE_FAILURE,
  CREATE_SINGLE_PURCHASE,
  CREATE_SINGLE_PURCHASE_SUCCESS,
  CREATE_SINGLE_PURCHASE_FAILURE,
  UPDATE_SINGLE_PURCHASE,
  UPDATE_SINGLE_PURCHASE_SUCCESS,
  UPDATE_SINGLE_PURCHASE_FAILURE,
  GET_PURCHASE_STATUS_LIST,
  GET_PURCHASE_STATUS_LIST_SUCCESS,
  GET_PURCHASE_STATUS_LIST_FAILURE,
  SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST,
  SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST_SUCCESS,
  SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST_FAILURE,
  GET_PURCHASE_ITEM_CATEGORY_LIST,
  GET_PURCHASE_ITEM_CATEGORY_LIST_SUCCESS,
  GET_PURCHASE_ITEM_CATEGORY_LIST_FAILURE,
  SEARCH_PURCHASE_ITEM_BY_JOB_ID,
  SEARCH_PURCHASE_ITEM_BY_JOB_ID_SUCCESS,
  SEARCH_PURCHASE_ITEM_BY_JOB_ID_FAILURE,
  CONVERT_PURCHASE_ITEM_TO_BILLABLE,
  CONVERT_PURCHASE_ITEM_TO_BILLABLE_SUCCESS,
  CONVERT_PURCHASE_ITEM_TO_BILLABLE_FAILURE,
  UNLINK_PURCHASE_ITEM_BILLABLE,
  UNLINK_PURCHASE_ITEM_BILLABLE_SUCCESS,
  UNLINK_PURCHASE_ITEM_BILLABLE_FAILURE,
  MARK_PURCHASE_ITEM_BILLED,
  MARK_PURCHASE_ITEM_BILLED_SUCCESS,
  MARK_PURCHASE_ITEM_BILLED_FAILURE,
  MARK_PURCHASE_ITEM_IGNORED,
  MARK_PURCHASE_ITEM_IGNORED_SUCCESS,
  MARK_PURCHASE_ITEM_IGNORED_FAILURE,
  ADD_NEW_PURCHASE_STATUS,
  ADD_NEW_PURCHASE_STATUS_SUCCESS,
  ADD_NEW_PURCHASE_STATUS_FAILURE,
  DELETE_PURCHASE_STATUS,
  DELETE_PURCHASE_STATUS_SUCCESS,
  DELETE_PURCHASE_STATUS_FAILURE,
  UPDATE_PURCHASE_STATUS,
  UPDATE_PURCHASE_STATUS_SUCCESS,
  UPDATE_PURCHASE_STATUS_FAILURE,
  ADD_NEW_PURCHASE_ITEM_CATEGORY,
  ADD_NEW_PURCHASE_ITEM_CATEGORY_SUCCESS,
  ADD_NEW_PURCHASE_ITEM_CATEGORY_FAILURE,
  DELETE_PURCHASE_ITEM_CATEGORY,
  DELETE_PURCHASE_ITEM_CATEGORY_SUCCESS,
  DELETE_PURCHASE_ITEM_CATEGORY_FAILURE,
  UPDATE_PURCHASE_ITEM_CATEGORY,
  UPDATE_PURCHASE_ITEM_CATEGORY_SUCCESS,
  UPDATE_PURCHASE_ITEM_CATEGORY_FAILURE,
  DELETE_SINGLE_PURCHASE,
  DELETE_SINGLE_PURCHASE_SUCCESS,
  DELETE_SINGLE_PURCHASE_FAILURE,
  SEARCH_PURCHASE_ITEM_LIST,
  SEARCH_PURCHASE_ITEM_LIST_SUCCESS,
  SEARCH_PURCHASE_ITEM_LIST_FAILURE,
  UPLOAD_PURCHASE_DRAFT,
  UPLOAD_PURCHASE_DRAFT_SUCCESS,
  UPLOAD_PURCHASE_DRAFT_FAILURE,
  CREATE_FILE_ATTACHMENT,
  CREATE_FILE_ATTACHMENT_SUCCESS,
  CREATE_FILE_ATTACHMENT_FAILURE,
  SEARCH_PURCHASE_ATTACHMENT,
  SEARCH_PURCHASE_ATTACHMENT_SUCCESS,
  SEARCH_PURCHASE_ATTACHMENT_FAILURE,
  DELETE_JOB_ATTACHMENT,
  DELETE_JOB_ATTACHMENT_SUCCESS,
  DELETE_JOB_ATTACHMENT_FAILURE,
  PREDICT_TRANSACTION_FINANCIAL,
  PREDICT_TRANSACTION_FINANCIAL_SUCCESS,
  PREDICT_TRANSACTION_FINANCIAL_FAILURE,
} from "./actionType";

// Get Purchase List Action

export const getPurchaseList = () => ({
  type: GET_PURCHASE_LIST,
});

export const getPurchaseListSuccess = (purchaseList) => ({
  type: GET_PURCHASE_LIST_SUCCESS,
  payload: purchaseList,
});

export const getPurchaseListFailure = (error) => ({
  type: GET_PURCHASE_LIST_FAILURE,
  payload: error,
});

// Get Single Purchase Action

export const getSinglePurchase = (id) => ({
  type: GET_SINGLE_PURCHASE,
  payload: id,
});

export const getSinglePurchaseSuccess = (purchase) => ({
  type: GET_SINGLE_PURCHASE_SUCCESS,
  payload: purchase,
});

export const getSinglePurchaseFailure = (error) => ({
  type: GET_SINGLE_PURCHASE_FAILURE,
  payload: error,
});

// Create Single Purchase Action

export const createSinglePurchase = (purchase) => ({
  type: CREATE_SINGLE_PURCHASE,
  payload: purchase,
});

export const createSinglePurchaseSuccess = (purchase) => ({
  type: CREATE_SINGLE_PURCHASE_SUCCESS,
  payload: purchase,
});

export const createSinglePurchaseFailure = (error) => ({
  type: CREATE_SINGLE_PURCHASE_FAILURE,
  payload: error,
});

// Update Single Purchase Action

export const updateSinglePurchase = (purchase) => ({
  type: UPDATE_SINGLE_PURCHASE,
  payload: purchase,
});

export const updateSinglePurchaseSuccess = (purchase) => ({
  type: UPDATE_SINGLE_PURCHASE_SUCCESS,
  payload: purchase,
});

export const updateSinglePurchaseFailure = (error) => ({
  type: UPDATE_SINGLE_PURCHASE_FAILURE,
  payload: error,
});

// Purchase Status List Action

export const getPurchaseStatusList = () => ({
  type: GET_PURCHASE_STATUS_LIST,
});

export const getPurchaseStatusListSuccess = (purchaseStatusList) => ({
  type: GET_PURCHASE_STATUS_LIST_SUCCESS,
  payload: purchaseStatusList,
});

export const getPurchaseStatusListFailure = (error) => ({
  type: GET_PURCHASE_STATUS_LIST_FAILURE,
  payload: error,
});

// Single Supplier Purchase List Action

export const searchSingleSupplierPurchaseList = (supplierId) => ({
  type: SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST,
  payload: supplierId,
});

export const searchSingleSupplierPurchaseListSuccess = (purchaseList) => ({
  type: SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST_SUCCESS,
  payload: purchaseList,
});

export const searchSingleSupplierPurchaseListFailure = (error) => ({
  type: SEARCH_SINGLE_SUPPLIER_PURCHASE_LIST_FAILURE,
  payload: error,
});

// Purchase Item Category List Action

export const getPurchaseItemCategoryList = () => ({
  type: GET_PURCHASE_ITEM_CATEGORY_LIST,
});

export const getPurchaseItemCategoryListSuccess = (
  purchaseItemCategoryList
) => ({
  type: GET_PURCHASE_ITEM_CATEGORY_LIST_SUCCESS,
  payload: purchaseItemCategoryList,
});

export const getPurchaseItemCategoryListFailure = (error) => ({
  type: GET_PURCHASE_ITEM_CATEGORY_LIST_FAILURE,
  payload: error,
});

// Search Purchase Item By Job Id Action

export const searchPurchaseItemByJobId = (jobId) => ({
  type: SEARCH_PURCHASE_ITEM_BY_JOB_ID,
  payload: jobId,
});

export const searchPurchaseItemByJobIdSuccess = (purchaseItemList) => ({
  type: SEARCH_PURCHASE_ITEM_BY_JOB_ID_SUCCESS,
  payload: purchaseItemList,
});

export const searchPurchaseItemByJobIdFailure = (error) => ({
  type: SEARCH_PURCHASE_ITEM_BY_JOB_ID_FAILURE,
  payload: error,
});

// Convert Purchase Item To Billable Action
export const convertPurchaseItemToBillable = (data) => ({
  type: CONVERT_PURCHASE_ITEM_TO_BILLABLE,
  payload: data,
});

export const convertPurchaseItemToBillableSuccess = (response) => ({
  type: CONVERT_PURCHASE_ITEM_TO_BILLABLE_SUCCESS,
  payload: response,
});

export const convertPurchaseItemToBillableFailure = (error) => ({
  type: CONVERT_PURCHASE_ITEM_TO_BILLABLE_FAILURE,
  payload: error,
});

// Unlink Purchase Item Billable Action
export const unlinkPurchaseItemBillable = (data) => ({
  type: UNLINK_PURCHASE_ITEM_BILLABLE,
  payload: data,
});

export const unlinkPurchaseItemBillableSuccess = (response) => ({
  type: UNLINK_PURCHASE_ITEM_BILLABLE_SUCCESS,
  payload: response,
});

export const unlinkPurchaseItemBillableFailure = (error) => ({
  type: UNLINK_PURCHASE_ITEM_BILLABLE_FAILURE,
  payload: error,
});

// Mark Purchase Item Billed Action
export const markPurchaseItemBilled = (data) => ({
  type: MARK_PURCHASE_ITEM_BILLED,
  payload: data,
});

export const markPurchaseItemBilledSuccess = (response) => ({
  type: MARK_PURCHASE_ITEM_BILLED_SUCCESS,
  payload: response,
});

export const markPurchaseItemBilledFailure = (error) => ({
  type: MARK_PURCHASE_ITEM_BILLED_FAILURE,
  payload: error,
});

// Mark Purchase Item Ignored Action (never billable - cost sits inside another price)
export const markPurchaseItemIgnored = (data) => ({
  type: MARK_PURCHASE_ITEM_IGNORED,
  payload: data,
});

export const markPurchaseItemIgnoredSuccess = (response) => ({
  type: MARK_PURCHASE_ITEM_IGNORED_SUCCESS,
  payload: response,
});

export const markPurchaseItemIgnoredFailure = (error) => ({
  type: MARK_PURCHASE_ITEM_IGNORED_FAILURE,
  payload: error,
});

// Add New Purchase Status Action
export const addNewPurchaseStatus = (purchaseStatus) => ({
  type: ADD_NEW_PURCHASE_STATUS,
  payload: purchaseStatus,
});

export const addNewPurchaseStatusSuccess = (purchaseStatus) => ({
  type: ADD_NEW_PURCHASE_STATUS_SUCCESS,
  payload: purchaseStatus,
});

export const addNewPurchaseStatusFailure = (error) => ({
  type: ADD_NEW_PURCHASE_STATUS_FAILURE,
  payload: error,
});

// Delete Purchase Status Action
export const deletePurchaseStatus = (purchaseStatus) => ({
  type: DELETE_PURCHASE_STATUS,
  payload: purchaseStatus,
});

export const deletePurchaseStatusSuccess = (purchaseStatus) => ({
  type: DELETE_PURCHASE_STATUS_SUCCESS,
  payload: purchaseStatus,
});

export const deletePurchaseStatusFailure = (error) => ({
  type: DELETE_PURCHASE_STATUS_FAILURE,
  payload: error,
});

// Update Purchase Status Action
export const updatePurchaseStatus = (purchaseStatus) => ({
  type: UPDATE_PURCHASE_STATUS,
  payload: purchaseStatus,
});

export const updatePurchaseStatusSuccess = (purchaseStatus) => ({
  type: UPDATE_PURCHASE_STATUS_SUCCESS,
  payload: purchaseStatus,
});

export const updatePurchaseStatusFailure = (error) => ({
  type: UPDATE_PURCHASE_STATUS_FAILURE,
  payload: error,
});

// Add New Purchase Item Category Action
export const addNewPurchaseItemCategory = (purchaseItemCategory) => ({
  type: ADD_NEW_PURCHASE_ITEM_CATEGORY,
  payload: purchaseItemCategory,
});

export const addNewPurchaseItemCategorySuccess = (purchaseItemCategory) => ({
  type: ADD_NEW_PURCHASE_ITEM_CATEGORY_SUCCESS,
  payload: purchaseItemCategory,
});

export const addNewPurchaseItemCategoryFailure = (error) => ({
  type: ADD_NEW_PURCHASE_ITEM_CATEGORY_FAILURE,
  payload: error,
});

// Delete Purchase Item Category Action
export const deletePurchaseItemCategory = (purchaseItemCategory) => ({
  type: DELETE_PURCHASE_ITEM_CATEGORY,
  payload: purchaseItemCategory,
});

export const deletePurchaseItemCategorySuccess = (purchaseItemCategory) => ({
  type: DELETE_PURCHASE_ITEM_CATEGORY_SUCCESS,
  payload: purchaseItemCategory,
});

export const deletePurchaseItemCategoryFailure = (error) => ({
  type: DELETE_PURCHASE_ITEM_CATEGORY_FAILURE,
  payload: error,
});

// Update Purchase Item Category Action
export const updatePurchaseItemCategory = (purchaseItemCategory) => ({
  type: UPDATE_PURCHASE_ITEM_CATEGORY,
  payload: purchaseItemCategory,
});

export const updatePurchaseItemCategorySuccess = (purchaseItemCategory) => ({
  type: UPDATE_PURCHASE_ITEM_CATEGORY_SUCCESS,
  payload: purchaseItemCategory,
});

export const updatePurchaseItemCategoryFailure = (error) => ({
  type: UPDATE_PURCHASE_ITEM_CATEGORY_FAILURE,
  payload: error,
});

// Delete Single Purchase Action
export const deleteSinglePurchase = (purchase) => ({
  type: DELETE_SINGLE_PURCHASE,
  payload: purchase,
});

export const deleteSinglePurchaseSuccess = (payload) => ({
  type: DELETE_SINGLE_PURCHASE_SUCCESS,
  payload,
});

export const deleteSinglePurchaseFailure = (payload) => ({
  type: DELETE_SINGLE_PURCHASE_FAILURE,
  payload,
});

// Search Purchase Item List Action
export const searchPurchaseItemList = (payload) => ({
  type: SEARCH_PURCHASE_ITEM_LIST,
  payload,
});

export const searchPurchaseItemListSuccess = (payload) => ({
  type: SEARCH_PURCHASE_ITEM_LIST_SUCCESS,
  payload,
});

export const searchPurchaseItemListFailure = (payload) => ({
  type: SEARCH_PURCHASE_ITEM_LIST_FAILURE,
  payload,
});

// Upload Purchase Draft Action
export const uploadPurchaseDraft = (payload) => ({
  type: UPLOAD_PURCHASE_DRAFT,
  payload,
});

export const uploadPurchaseDraftSuccess = (payload) => ({
  type: UPLOAD_PURCHASE_DRAFT_SUCCESS,
  payload,
});

export const uploadPurchaseDraftFailure = (payload) => ({
  type: UPLOAD_PURCHASE_DRAFT_FAILURE,
  payload,
});

// Create File Attachment Action
export const createFileAttachment = (payload) => ({
  type: CREATE_FILE_ATTACHMENT,
  payload,
});

export const createFileAttachmentSuccess = (payload) => ({
  type: CREATE_FILE_ATTACHMENT_SUCCESS,
  payload,
});

export const createFileAttachmentFailure = (payload) => ({
  type: CREATE_FILE_ATTACHMENT_FAILURE,
  payload,
});

// Search Purchase Attachment Action
export const searchPurchaseAttachment = (payload) => ({
  type: SEARCH_PURCHASE_ATTACHMENT,
  payload,
});

export const searchPurchaseAttachmentSuccess = (payload) => ({
  type: SEARCH_PURCHASE_ATTACHMENT_SUCCESS,
  payload,
});

export const searchPurchaseAttachmentFailure = (payload) => ({
  type: SEARCH_PURCHASE_ATTACHMENT_FAILURE,
  payload,
});

// Delete Job Attachment Action
export const deleteJobAttachment = (payload) => ({
  type: DELETE_JOB_ATTACHMENT,
  payload,
});

export const deleteJobAttachmentSuccess = (payload) => ({
  type: DELETE_JOB_ATTACHMENT_SUCCESS,
  payload,
});

export const deleteJobAttachmentFailure = (payload) => ({
  type: DELETE_JOB_ATTACHMENT_FAILURE,
  payload,
});

// Predict Transaction Financial
export const predictTransactionFinancial = (payload) => ({
  type: PREDICT_TRANSACTION_FINANCIAL,
  payload,
});

export const predictTransactionFinancialSuccess = (payload) => ({
  type: PREDICT_TRANSACTION_FINANCIAL_SUCCESS,
  payload,
});

export const predictTransactionFinancialFailure = (payload) => ({
  type: PREDICT_TRANSACTION_FINANCIAL_FAILURE,
  payload,
});
